export default {
  //通用跳转
  toUrl(that, path, param){
    that.$router.push({
      path: path,
      query: param?param:{}
    })
  },


  // 设置语言
  setLanguage(that){
    // zh_CN: 简体中文语言包
    // en_US: 英文语言包
    // zh_TW: 繁体中文语言包
    // ja_JP: 日语语言包
    var type = localStorage.getItem('lang') || 1;
    if (type == 1) {
      that.$i18n.locale = "ja_JP";
    } else if (type == 2) {
      that.$i18n.locale = "en_US";
    } else if (type == 3) {
      that.$i18n.locale = "zh_CN";
    } else if (type == 4) {
      that.$i18n.locale = "zh_TW";
    }
    localStorage.setItem('lang', type);
  },

  //判断是否为空
  isnull(val) {
    if (val == "" || val == null || val == undefined || val == " ")
      return true;
    return false;
  },
  //倒计时
  countDown(obj,num) {
    if(num==1){
      var Timer = setInterval(() => {
        if (obj.code_time > 0) {
          obj.code_time--;
          obj.code_text = `${obj.code_time}秒后获取`;
          obj.code_flag = false;
        } else {
          obj.code_flag = true;
          obj.code_time = 60;
          obj.code_text = `重新获取`;
          clearInterval(Timer);
        }
      }, 1000)
    }else{
      var Timer = setInterval(() => {
        if (obj.re_code_time > 0) {
          obj.re_code_time--;
          obj.re_code_text = `${obj.re_code_time}秒后获取`;
          obj.re_code_flag = false;
        } else {
          obj.re_code_flag = true;
          obj.re_code_time = 60;
          obj.re_code_text = `重新获取`;
          clearInterval(Timer);
        }
      }, 1000)
    }

  },
  //默认图设置
  pic(obj) {
    // obj.defaultPic = 'this.src="' + require('@/assets/images/default.png') + '"'; //默认图
  },

  //判断是否登录
  isLogin(that){
    if(this.isnull(that.$cookies.get("token"))){
      return false;
    }else {
      return true;
    }
  },

  /* 是否手机号码*/
  isMobile(value, callback) {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (value == '' || value == undefined || value == null) {
      return false;
    } else {
      if ((!reg.test(value)) && value != '') {
        return false;
      }else {
        return true;
      }
    }
  },


  //时间戳  转 年月日
  add0(m){
    return m<10?'0'+m:m
  },
  format(timestamp, type) {
    //timestamp是整数，否则要parseInt转换
    var time = new Date(timestamp);
    var y = time.getFullYear();
    var m = time.getMonth()+1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    if(type == 'yyyy-mm-dd'){
      return y+'.'+this.add0(m)+'.'+this.add0(d);
    }else if(type == 'mm-dd'){
      return this.add0(m)+'.'+this.add0(d);
    }else if(type == 'yyyy-mm-dd hh:mm:ss'){
        return y+'.'+this.add0(m)+'.'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm)+':'+this.add0(s);
    }else if(type == 'yyyy-mm-dd hh:mm'){
        return y+'.'+this.add0(m)+'.'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm);
    }else if(type == 'yyyy/mm/dd'){
      return y+'/'+this.add0(m)+'/'+this.add0(d);
    }
    
  },

  //获取链接上参数
  getParam(variable) {
    var query = window.location.search.substring(1);
    var query3 = window.location.href.split("?");
    query = query + '&' + query3[1] + '&' + query3[2];
    console.log("param："+query);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return (false);
  },

  //判断是否为ios
  isIOS() {
    var isIphone = navigator.userAgent.includes('iPhone');
    var isIpad = navigator.userAgent.includes('iPad');
    return isIphone || isIpad;
  },

  //替换所有文字
  toReplaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  },






shareConfig(wx, share_href, data){
    wx.ready(function () {
      //分享到朋友圈
      wx.onMenuShareTimeline({
        title: data.share_title, // 分享时的标题
        link: share_href, // 分享时的链接
        imgUrl: data.share_icon, // 分享时的图标
        desc: data.share_desc, // 分享时的简介
        success: function (res) {
          console.log("success", res)
        },
        cancel: function (error) {
          console.log("error", error)
        }
      });


      //分享给朋友
      wx.onMenuShareAppMessage({
        title: data.share_title,// 分享时的标题
        link: share_href, // 分享时的链接
        imgUrl: data.share_icon, // 分享时的图标
        type: '',
        desc: data.share_desc,// 分享时的简介
        dataUrl: '',
        success: function (res) {
          console.log("success", res)
        },
        cancel: function (error) {
          console.log("error", error)
        }
      });

    })
  },



  /**
   * 根据日期计算天数
   */
  computeDiffDays(date_1, date_2) {
    console.log('日期=====', date_1, date_2,)
      if (date_1 && date_1.indexOf(' ') >= 0) {
        date_1 = date_1.split(' ')[0]
      }
      if (date_2 && date_2.indexOf(' ') >= 0) {
        date_2 = date_2.split(' ')[0]
      }
      // 计算两个日期之间的天数差值
      let totalDays, diffDate
      let myDate_1 = Date.parse(date_1)
      let myDate_2 = Date.parse(date_2)
      // 将两个日期都转换为毫秒格式，然后做差
      diffDate = Math.abs(myDate_1 - myDate_2) // 取相差毫秒数的绝对值

      totalDays = Math.floor(diffDate / (1000 * 3600 * 24)) // 向下取整
      console.log('日期差值', totalDays)

      return totalDays    // 相差的天数
  },


  /**
   * 打开新标签页下载文件
   * @params {*} uploadURL 文件下载的服务器接口
   * @params {*} fileName 文件下载的文件名 后台返回
   */
  fileExport(uploadURL, fileName) {
    var url = uploadURL + '/profile/download/' + fileName
    window.open(url)
    // var el = document.createElement('a');
    // el.href = url;
    // el.download = fileName;
    // document.body.appendChild(el);
    // el.click();
    // el.remove();
  },

  // 只能输入正整数 第二个参数传true 可以为负数
  onlyInt(e, canMinus=false){
    console.log(e);
    let key = e.data // 获取输入值
    let value = e.target.value

    // // 输入了除数字以外的字符
    // if (
    //   !["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"].includes(key) 
    //   && e.inputType != 'insertFromPaste'
    //   && e.inputType != 'deleteContentBackward'
    //   && e.inputType != 'deleteWordBackward'
    //   && e.inputType != 'deleteByCut'
    // ) {
    //   Message.warning('只能输入正整数')
    //   // 去除刚刚输入的非数字字符
    //   value = value.substring(0, value.length-1)
    // }

    // if (e.inputType == 'insertFromPaste' && !/^[+]{0,1}(\d+)$/.test(value)) {
    //   Message.warning('粘贴内容不合法');
    //   value = ''
    // }

    if (canMinus) {
      if (!(Math.abs(Number(value))% 1===0)) {
        // value = '';
        // Message.warning('只能输入整数')
        e.target.value = ''
      }
      

    } else if (!/^[+]{0,1}(\d+)$/.test(value)) {
      // value = '';
      // Message.warning('只能输入正整数')
      e.target.value = ''
    }


    // 去掉头部的 0
    if (e.target.value.length>1) {
      e.target.value = value.replace(/\b(0+)/gi,"")
    }
  },

  // 只能输入正整数 第二个参数传true 可以为负数
  onlyFloat(e,maxLen = 10 ,doLen = 3 ,maxNum = null, canMinus=false){
    let key = e.data // 获取输入值
    let value = e.target.value
    let filterValue = value.toString();
    filterValue = filterValue.substr(0, maxLen); // 最多10位
    filterValue = filterValue.replace(/^\./g, "");  //  不能以“.”开头
    filterValue = filterValue.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符  
    filterValue = filterValue.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的  
    filterValue = filterValue.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    let dolength = '';
    for (let index = 0; index < doLen; index++) {
      dolength += '\\d';
      
    }
    // /^(\-)*(\d+)\.(\d\d\d).*$/
    // /^(-)*(d+).(ddd).*$\//g
    let doReg = RegExp("^(\\-)*(\\d+)\\.("+dolength+").*$","");
    filterValue = filterValue.replace(doReg, '$1$2.$3');//只能输入3个小数  
    if (filterValue.indexOf(".") < 0 && filterValue != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
      filterValue = filterValue.substr(0, 10)
      filterValue = parseFloat(filterValue);
    }
    if(maxNum && filterValue > Number(maxNum)){
      filterValue = maxNum;
    }
    console.log(maxNum && filterValue > Number(maxNum));

    console.log(filterValue);
    e.target.value = filterValue;
   
  },
}



// WEBPACK FOOTER //
// ./src/utils/utils.js